<template>
    <button class="c-button" @click.stop="share()">
        <font-awesome-icon :class="{'c-button__left-icon': variant !== 'iconOnly'}" icon="share-alt"></font-awesome-icon>
        <span v-if="variant === 'basic'">Share</span>
    </button>
</template>

<script>
    export default {
        name: "share-button",
        props: {
            parent: {
                type: Object,
                default: null
            },
            variant: {
                type: String,
                default: 'iconOnly',
                validator: (value) => {
                    // The value must match one of these strings
                    // Basic: Icon + Share Label
                    return ['iconOnly', 'basic'].indexOf(value) !== -1;
                }
            },
            item: {
                type: Object,
                required: true
            }
        },
        computed: {
            shareModal() {
                return this.$store.state.shareModal;
            }
        },
        methods: {
            share() {
                this.$store.commit("shareable", {shareable: this.item});
                this.$store.commit("shareFromPage", {shareFromPage: this.parent});
                if (this.shareModal) {
                    this.shareModal.modal('show');
                }
            },
        }
    }
</script>

<style scoped>

</style>